import { render, staticRenderFns } from "./Pos-kitchen-order.vue?vue&type=template&id=b9c483a6&"
import script from "./Pos-kitchen-order.vue?vue&type=script&lang=js&"
export * from "./Pos-kitchen-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports